import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

export const INVITE_ERRORS = new Set([
  "INVITE_NOT_FOUND",
  "INVITE_REVOKED",
  "INVITE_EXPIRED",
  "INVITE_EXHAUSTED",
  "INVITE_EMAIL_MISMATCH",
  "INVITE_INVALID",
]);

export const SOCIAL_FAILED_KEY = "socialFailed";
export const GOOGLE_NOT_INVITED_KEY = "invite.googleNotInvited";

/** `auth` namespace key for a code BetterAuth put in `?error=` after a failed OAuth callback. */
function oauthErrorKey(code: string): string {
  // Via Google there is no code to mistype: not found means this address has no invite.
  if (code === "INVITE_NOT_FOUND") return GOOGLE_NOT_INVITED_KEY;
  if (INVITE_ERRORS.has(code)) return `invite.errors.${code}`;
  return SOCIAL_FAILED_KEY;
}

/**
 * Reads the OAuth failure BetterAuth appends to `errorCallbackURL` once on mount, then strips it
 * from the URL so a refresh doesn't show it again. Returns the `auth` key to translate, or null.
 */
export function useOAuthErrorKey(): string | null {
  const [params, setParams] = useSearchParams();
  const [key] = useState(() => {
    const code = params.get("error");
    return code ? oauthErrorKey(code) : null;
  });

  useEffect(() => {
    if (!params.has("error") && !params.has("error_description")) return;
    const next = new URLSearchParams(params);
    next.delete("error");
    next.delete("error_description");
    setParams(next, { replace: true });
  }, [params, setParams]);

  return key;
}
